<div class="container">
    <app-loading-panel [showLoading]="loading" [variant]="'overlay'" [hideText]="true"></app-loading-panel>
    <form #ryftPaymentForm class="paymentWidgets ryft-payment-form" id="ryft-pay-form" (ngSubmit)="submitPayment()">
        <button id="ryft-pay-btn" [disabled]="!payButtonEnabled">PAY {{paymentDetails?.requestJSON?.paymentFormParams?.currencySymbol}}{{getAmount()}}</button>
        <div id="ryft-pay-error"></div>
    </form>
</div>
